import { getCoordinatorApi } from "@/lib/api";
import type { OrgProjectScope } from "@/lib/resource-context";

export const updateProjectMemberRole = async ({
  memberId,
  role,
  scope,
}: {
  memberId: string;
  role: string;
  scope: OrgProjectScope;
}): Promise<void> => {
  const client = getCoordinatorApi(scope);
  await client.put(`/members/${memberId}`, { role });
};
